var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#28C0E2",
    stroke: "#28C0E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5699_2612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.086 19.9135L30.0866 23.9141L21.3994 32.6013L17.8325 32.9951C17.355 33.0479 16.9516 32.6441 17.0047 32.1666L17.4016 28.5973L26.086 19.9135ZM32.561 19.3179L30.6825 17.4395C30.0966 16.8535 29.1463 16.8535 28.5603 17.4395L26.7932 19.2066L30.7938 23.2073L32.561 21.4401C33.1469 20.8538 33.1469 19.9038 32.561 19.3179Z",
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5699_2612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBtn);
export default __webpack_public_path__ + "static/media/contact-btn.84b492c789ff1ea59cc0850111dd585d.svg";
export { ForwardRef as ReactComponent };